import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { EditPriceResourcePackage } from "../resources/EditPriceResourcePackage";

export class EditPriceContainer extends Container {
    public constructor(editPriceResources: EditPriceResourcePackage) {
        super();
        const glassFrame = new Sprite(editPriceResources.assets_views_edit_price_images_frame_png);
        this.addChild(glassFrame);
        const headerText = new Text("ENTER NEW PRICE IN USD", new HeaderTextStyle());
        headerText.position.set(glassFrame.width * 0.5 - headerText.width * 0.5, 143);
        this.addChild(headerText);
    }
}

class HeaderTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40
        }));
    }
}
